// extracted by mini-css-extract-plugin
export default {"container":"Section_container__IjtES","header":"Section_header__zS3g9","body":"Section_body__0-Eai"};